<script>
  import {
    VFooter
  } from 'vuetify/lib'
  export default {
    name: 'wh-footer',
    extends: VFooter
  };
</script>